import axios from "axios";

// Customer info interface
export interface ICustomerInfo {
  id: string;
  name: string;
  company: string;
  position?: string;
  phone: string;
  email: string;
  address?: string;
  washType?: string;
  message?: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export class CustomerInfoService {
  private static rootUrl = '/api/customer-info';
  private static client = axios;

  /**
   * Fetches customer information for the currently logged-in account
   * @returns CustomerInfo object with account details
   */
  static async getMyCustomerInfo(): Promise<ICustomerInfo> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Nicht angemeldet');
    }

    try {
      const response = await this.client.get(`${this.rootUrl}/by-account/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data.customerInfo;
    } catch (error: any) {
      if (error.response?.status === 404) {
        throw new Error('Keine Kundeninformationen gefunden');
      }
      console.error('Failed to fetch customer info:', error);
      throw new Error('Fehler beim Abrufen der Kundeninformationen');
    }
  }

  /**
   * Updates customer information for the currently logged-in account
   * @param customerData Updated customer data
   * @returns Updated CustomerInfo object
   */
  static async updateMyCustomerInfo(customerData: Partial<ICustomerInfo>): Promise<ICustomerInfo> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Nicht angemeldet');
    }

    try {
      const response = await this.client.patch(`${this.rootUrl}/by-account/me`, customerData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data.customerInfo;
    } catch (error: any) {
      if (error.response?.status === 404) {
        throw new Error('Keine Kundeninformationen gefunden');
      } else if (error.response?.status === 400) {
        const errorMessage = error.response.data?.message || 'Validierungsfehler';
        throw new Error(errorMessage);
      }
      console.error('Failed to update customer info:', error);
      throw new Error('Fehler beim Aktualisieren der Kundeninformationen');
    }
  }
} 